import { render, staticRenderFns } from "./GameShop.vue?vue&type=template&id=7b55b79b&"
import script from "./GameShop.vue?vue&type=script&lang=js&"
export * from "./GameShop.vue?vue&type=script&lang=js&"
import style0 from "./GameShop.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports